export default {
      id: "Icon--timer-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--timer",
      toString: function () {
        return this.url;
      }
    }